/*
    创建者：shuxiaokai
    创建时间：2020-05-12 10:10
    模块名称：数据配置
    备注：xxxx
*/
<template>
    <div>
        <el-form ref="form" :model="formInfo" label-width="120px" class="data-config pt-2 mr-5">
            {{ formInfo }}
            <el-divider content-position="left">数据过滤条件</el-divider>
            <el-form-item label="日期过滤:">
                <s-time-select></s-time-select>
            </el-form-item>
            <el-form-item label="地区选择：">
                <s-area-select></s-area-select>
            </el-form-item>
            <el-form-item label="环节：">
                <el-checkbox-group v-model="formInfo.link" size="mini">
                    <el-checkbox-button label="全部"></el-checkbox-button>
                    <el-checkbox-button label="生产"></el-checkbox-button>
                    <el-checkbox-button label="流通"></el-checkbox-button>
                    <el-checkbox-button label="餐饮"></el-checkbox-button>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="任务来源：">
                <el-checkbox-group v-model="formInfo.area" size="mini">
                    <el-checkbox-button label="全部"></el-checkbox-button>
                    <el-checkbox-button label="国转移"></el-checkbox-button>
                    <el-checkbox-button label="省本级"></el-checkbox-button>
                    <el-checkbox-button label="市本级"></el-checkbox-button>
                    <el-checkbox-button label="区本级"></el-checkbox-button>
                    <el-checkbox-button label="市转移"></el-checkbox-button>
                </el-checkbox-group>
            </el-form-item>
            <el-divider content-position="left">中文解释</el-divider>
            <div>
                <span class="mr-1">2018年</span>====
                <span class="mr-1">全国</span>====
                <span class="mr-1">生产环节</span>====
                <span class="mr-1">国转移抽检批次数</span>====
                <span class="mr-1 teal">888</span>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            //=====================================表单参数====================================//
            formInfo: {
                time: [], //日期
                link: [], //环节
                area: [], //地区
                origin: [], //数据源
            },
            //=====================================xxxx====================================//

        };
    },
    created() {

    },
    methods: {
        //=====================================获取远程数据==================================//
       
        //=====================================前后端交互====================================//

        //=====================================组件间交互====================================//  
        //地区选择
        handleSelectArea() {
            
        },
        //=====================================其他操作=====================================//

    }
};
</script>



<style lang="scss">
.data-config {
    .el-form-item {
        // margin-bottom: size(10);
        height: size(30);
    }
    .el-form-item__label {
        height: 100%;
        line-height: normal;
        display: inline-flex;
        align-items: center;
        justify-content: flex-end;
    }
    .el-form-item__content {
        line-height: normal;
        display: flex;
        align-items: center;
    }
}
</style>
